import { type FC, type ReactNode } from 'react';
import { ComponentLoader } from './ComponentLoader/ComponentLoader';
import { type Environment } from 'react-relay';
import { type DisplayPromoCodeWrapperProps } from 'dibs-display-promo-code';

/**
 * PromoCode Component Loader (dibs-display-promo-code)
 */
const importFunc = (): Promise<ReactNode> => {
    return import(
        /* webpackChunkName: "PromoCode" */
        'dibs-display-promo-code'
    ).then(esExport => esExport.default) as Promise<ReactNode>;
};

type Props = Exclude<DisplayPromoCodeWrapperProps, 'viewer'> & {
    load: boolean;
    environment?: Environment;
    itemId?: string;
};

export const PromoCodeLoader: FC<Props> = ({ load, ...props }) => {
    return (
        <ComponentLoader
            {...props}
            load={load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
};
